import { render, staticRenderFns } from "./priceListTemplate.vue?vue&type=template&id=625648ae&"
import script from "./priceListTemplate.vue?vue&type=script&lang=js&"
export * from "./priceListTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports